import PageCheckout from '@/pages/PageCheckout'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageCheckout,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}